import React from "react";
import PropTypes from "prop-types";
import { Anchor, FooterWrap } from "./animo-component";
import Typography from "../common-components/Typography";
import { font } from "../constants/font";
import content from "../constants/content";

const Footer = ({ isExport }) => {
  const getYear = new Date().getFullYear();
  return (
    <FooterWrap isExport={isExport}>
      <p>
        Copyright © {getYear} <span> Animaker Inc. </span> All rights Reserved.
      </p>
      <Anchor className="footer-link">
        <Typography
          content={content.FEEDBACK}
          target="_blank"
          href="https://www.vmaker.com/feedback"
          font={font.normalBase_21}
          color={"#32304A"}
          isAnchor
          cursor="pointer"
        />
        <Typography
          content={content.TERMS}
          font={font.normalBase_21}
          color={"#32304A"}
          isAnchor
          cursor="pointer"
          target="_blank"
          href="https://www.vmaker.com/terms-policy"
        />
        <Typography
          content={content.SUPPORT}
          target="_blank"
          href="https://www.vmaker.com/support"
          font={font.normalBase_21}
          color={"#32304A"}
          isAnchor
          cursor="pointer"
          padding="0px 40px 0px 0px"
        />
      </Anchor>
    </FooterWrap>
  );
};
Footer.propTypes = {
  isExport: PropTypes.bool,
};
export default Footer;
